import React from "react";
import { Navigate, LoaderFunctionArgs } from "react-router-dom";
import graphQLClient from "../apollo-client";
import { MEDICATION_CONDITION_PAIRS_QUERY } from "../pages/my-appeals/medication-condition-eligibility-form";
import PathConstants from "./path-constants";

const CoverageFundEligibilityPage = React.lazy(
  () =>
    import("../pages/product/eligibility/coverage-fund/coverage-fund-eligibility"),
);
const MedicationConditionEligibilityPage = React.lazy(
  () => import("../pages/product/eligibility/medication-condition-eligibility"),
);
const CoverageFundQualifyPage = React.lazy(
  () =>
    import("../pages/product/eligibility/coverage-fund/coverage-fund-qualify"),
);
const CoverageFundNotQualifyPage = React.lazy(
  () =>
    import("../pages/product/eligibility/coverage-fund/coverage-fund-not-qualify"),
);

const routes = [
  {
    path: PathConstants.Root,
    element: <Navigate to={PathConstants.MedicationConditionEligibility} />,
  },
  {
    path: PathConstants.CoverageFundEligibility,
    element: <CoverageFundEligibilityPage />,
  },
  {
    path: PathConstants.MedicationConditionEligibility,
    element: <MedicationConditionEligibilityPage />,
    loader: ({ request }: LoaderFunctionArgs) => {
      const coverageFundAppeal =
        new URL(request.url).searchParams.get("coverageFund") === "true";
      graphQLClient.query({
        query: MEDICATION_CONDITION_PAIRS_QUERY,
        variables: { coverageFundAppeal },
        fetchPolicy: "network-only",
      });
      return null;
    },
  },
  {
    path: PathConstants.CoverageFundQualify,
    element: <CoverageFundQualifyPage />,
  },
  {
    path: PathConstants.CoverageFundNotQualify,
    element: <CoverageFundNotQualifyPage />,
  },
];

export default routes;
